import React, { Component } from "react";
import styled from "styled-components";
import * as Widget from "./Widget2";

const Data = [
  {
    img: "photo01.png",
    name: "自家烘焙的職人精神",
    description:
      "「只有自己親手烘出的豆子才能賦予靈魂跟情感」我們相信充滿生命力的咖啡豆一定來自千錘百鍊的手感與經驗。\n\n"
  },
  {
    img: "photo02.png",
    name: "手沖單品的專業保證",
    description:
      "「每杯手沖單品咖啡都有個不應該被忽略的故事」透過咖啡師對單品的介紹與專業分享，讓咖啡愛好者的人享受那種喝下一杯故事的感覺。\n\n"
  },
  {
    img: "photo03.png",
    name: "極致體驗的店家理念",
    description:
      "「品牌咖啡店的存在會讓咖啡變得層次更加豐富」好的咖啡店創造空間與人的連結，全方位提升生活的質感。\n\n"
  }
];

class StorePromiseSection extends Component {
  render() {
    let { css } = this.props;

    return (
      <Wrapper css={css}>
        <div className="title">- 嚴選三大堅持 -</div>
        <Widget.Row
          justify="center"
          css={`
            @media screen and (max-width: 550px) {
              flex-wrap: wrap;
            }
          `}
        >
          {Data.map((d, i) => (
            <Item
              key={"product-promise-item" + i}
              img={`/images/pages/store/${d.img}`}
              css={`
                margin-right: 20px;
                @media screen and (max-width: 600px) {
                  margin-right: 10px;
                }
                @media screen and (max-width: 550px) {
                  margin-right: 0px;
                  margin-bottom: 20px;
                }
              `}
            >
              <h4 className="name">{d.name}</h4>
              <div className="description">{d.description}</div>
            </Item>
          ))}
        </Widget.Row>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  padding: 5px;
  width: 100%;
  & > .title {
    margin-bottom: 75px;
    text-align: center;
    letter-spacing: 3.9px;
    font-size: 26px;
  }

  @media screen and (max-width: 1000px) {
    & > .title {
      margin-bottom: 60px;
    }
  }

  ${props => props.css}
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  padding: 20px;
  max-width: 360px;
  width: 100%;
  min-height: 326px;

  background-color: lightgray;
  background-image: url(${props => props.img});
  background-position: center;
  background-size: cover;
  color: white;

  & > .name {
    margin-bottom: 17px;
    font-weight: 400;
    font-size: 20px;
  }

  & > .description {
    white-space: pre-wrap;
    line-height: 24px;
    font-size: 14px;
  }

  ${props => props.css};

  :last-child {
    margin: 0px;
  }

  @media screen and (max-width: 1200px) {
    max-width: 300px;
    min-height: 272px;
  }

  @media screen and (max-width: 1000px) {
    padding: 5px;
    max-width: 200px;
    min-height: 181px;

    & > .name {
      margin-bottom: 10px;
      font-size: 12px;
    }

    & > .description {
      white-space: normal;
      line-height: 20px;
      font-size: 12px;
    }
  }

  @media screen and (max-width: 550px) {
    padding: 15px;
    max-width: 360px;
    min-height: 326px;
    & > .name {
      margin-bottom: 17px;
      font-weight: 400;
      font-size: 20px;
    }

    & > .description {
      line-height: 24px;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 320px) {
    max-width: 300px;
    min-height: 272px;
  }
`;

export default StorePromiseSection;
